import Vue from "vue";
import Router from "vue-router";
import Home from "../components/home";
import Index from "../components/Index";
import Fruit from "../components/Fruit";
import Fashion from "../components/Fashion";
import Register from "../components/Register.vue";
Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/fruit",
      name: "Fruit",
      component: Fruit,
    },
    {
      path: "/fashion",
      name: "Fashion",
      component: Fashion,
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
  ],
});
